<template>
  <div class="scroll-hor-cont">
    <table class="form-calculadora">
      <tr class="form-titles">
        <th v-for="item in nombresCols">
          <p v-html="item"></p>
        </th>
      </tr>
      <tr >
        <td v-for="(item, index) in ingresosMasOtrosIngresos">
          <p :class="index > 0?'text-xs-center':'font-red'">{{index > 0?'$':''}}{{item}}</p>
        </td>
      </tr>
      <tr >
        <td v-for="(item, index) in totalGastos">
          <p :class="index > 0?'text-xs-center':'font-red'">{{index > 0?'$':''}}{{item}}</p>
        </td>
      </tr>
      <tr >
        <td v-for="(item, index) in flujoDeCaja">
          <p :class="index > 0?'text-xs-center':'font-red'">{{index > 0?'$':''}}{{item}}</p>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    nombresCols:{
      type: Array,
      required: true
    }
  },
  data() {
    return {     
    };
  },
  computed:{
    ingresosMasOtrosIngresos(){
      return this.$store.getters.ingresosMasOtrosIngresos
    },
    totalGastos(){
      return this.$store.getters.totalGastos
    },
    flujoDeCaja(){
      return this.$store.getters.flujoDeCaja
    },
  }
};
</script>


<style lang="scss" scoped>
@import "../../sass/helpers/variables";
.form-calculadora {
  width: 100%;
  max-width: 1150px;
  min-width: 900px;
  margin: auto;
  border-collapse: collapse;
  padding: 10px;
  .form-titles {
    border-bottom: solid 2px #bbb;
  }
  .form-end{
    border-top: solid 2px #bbb;
  }
  .input-td {
    text-align: center;
  }
  tr {
    th,
    td {
      width: 25%;
      padding: 5px 10px;
      font-size: 1.2rem;
      line-height: 1.4rem;
      input {
        border: solid 1px $primary-red;
        text-align: center;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// FormCalculadoraTotal.vue?3ac9dbe5